import { useFilterConfig } from '../hooks/useFilterConfig';
import { SelectFilter } from './reusableFilters/SelectFilter';
import { jsx as _jsx } from "react/jsx-runtime";
export function AgentFilterControls() {
  const {
    AGENT_TEAM
  } = useFilterConfig();
  return /*#__PURE__*/_jsx(SelectFilter, {
    filter: AGENT_TEAM,
    multi: true
  });
}